export default __webpack_public_path__ + "static/media/tablets.4e42ee51.svg";